import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Main from "./layouts/Main";
import NotFound from "./pages/NotFound";
import Home from "./pages/Home";


import publicRoutes from "./routes/PublicRoutes";
import protectedRoutes from "./routes/ProtectedRoutes";

// import css
import "./assets/css/remixicon.css";

// import scss
import "./scss/style.scss";
import Signin from "./pages/Signin";
import Signup from "./pages/Signup";
import { NaverCallback, KakaoCallback } from "./pages/LoginCallback";
import RequireAuth from "./routes/RequireAuth";

// set skin on load
window.addEventListener("load", function () {
  let skinMode = localStorage.getItem("skin-mode");
  let HTMLTag = document.querySelector("html");

  if (skinMode === "light") {
    HTMLTag.removeAttribute("data-skin");
  } else {
    HTMLTag.setAttribute("data-skin", "dark");
  }
});

export default function App() {
  return (
    <React.Fragment>
      <BrowserRouter>
        <Routes>
          <Route path="/pages/signin" element={<Signin />} />
          <Route path="/pages/signup" element={<Signup />} />
          <Route path="/auth/naver/callback" element={<NaverCallback />} />
          <Route path="/auth/kakao/callback" element={<KakaoCallback />} />
          <Route path="/dashboard" element={<Navigate to="/" replace />} />
          <Route path="/" element={<Main />}>
            <Route index element={<RequireAuth><Home /></RequireAuth>} />
            {protectedRoutes.map((route, index) => {
              return (
                <Route
                  path={route.path}
                  element={route.element}
                  key={index}
                />
              )
            })}
          </Route>
          {publicRoutes.map((route, index) => {
            return (
              <Route
                path={route.path}
                element={<RequireAuth>{route.element}</RequireAuth>}
                key={index}
              />
            )
          })}
          <Route path="/404.html" element={<NotFound />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </React.Fragment>
  );
}
